import { ROUTES } from ".";

export const MANAGE_TRANSACTION_ROUTES = {
  APPROVAL: `${ROUTES.TRANSACTION}/manage-approval`,
  DRAFT: `${ROUTES.TRANSACTION}/manage-draft`,
  HISTORY: `${ROUTES.TRANSACTION}/history`,
  PENDINGWITHDRAWAL: `${ROUTES.TRANSACTION}/manage-pending-withdrawal`,
  PENDINGLOAN: `${ROUTES.TRANSACTION}/manage-pending-loan`,
  PENDINGROLLOVERIN: `${ROUTES.TRANSACTION}/manage-pending-rolloverin`,
  PENDINGROLLOVERINAPPROVAL: `${ROUTES.TRANSACTION}/manage-pending-rolloverin-approval`,
  PENDINGWITHDRAWALAPPROVAL: `${ROUTES.TRANSACTION}/manage-pending-withdrawal-approval`,
  PENDINGLOANAPPROVAL: `${ROUTES.TRANSACTION}/manage-pending-loan-approval`,
  ROLLOVER_HISTORY_DETAILS: `${ROUTES.TRANSACTION}/rollover-history-details`,
  DISTRIBUTION_HISTORY_DETAILS: `${ROUTES.TRANSACTION}/withdrawal-history-details`,
  LOAN_HISTORY_DETAILS: `${ROUTES.TRANSACTION}/loan-history-details`,
  TRANSFER_HISTORY_DETAILS: `${ROUTES.TRANSACTION}/transfer-history-details`,
};

export const REVIEW_SCREEN_DATA_MAPPING = {
  APPROVAL: "approval",
  DRAFT: "draft",
  HISTORY: "history",
};
export const manageTransactionFormNames = {
  MANAGE_WITHDRWAL: "manage withdrawal",
  MANAGE_LOAN: "manage loan",
  MANAGE_ROLLOVERIN: "manage rolloverin",
  MANAGE_DRAFT: "manage draft",
};
export const transactionFormFields = {
  [manageTransactionFormNames.MANAGE_WITHDRWAL]: {
    // sort: "sort",
    isAscending: "isAscending",
    companyName: "companyName",
    companyId: "companyId",
    employeeId: "employeeId",
    planId: "planId",
    planName: "planName",
    uniquePersonalIdentification: "uniquePersonalIdentification",
    employeeName: "searchString",
    from: "from",
    userId: "userId",
    offset: "offset",
    requestedFrom: "requestedFrom",
    requestedTo: "requestedTo",
  },
  [manageTransactionFormNames.MANAGE_DRAFT]: {
    sort: "sort",
    pill: "pill",
    companyName: "companyName",
    planId: "planId",
    employeeName: "employeeName",
    requestedFrom: "requestedFrom",
    requestedTo: "requestedTo",
    transactionType: "transactionType",
    employeeId: "employeeId",
    userId: "userId",
    uniquePersonalIdentification: "uniquePersonalIdentification",

    // optionsinFilter: "optionsinFilter",
    employeeName: "search",
    isAscending: "isAscending",
    //  filterOut: "filterOut",
  },
  [manageTransactionFormNames.MANAGE_ROLLOVERIN]: {
    sort: "sort",
    pill: "pill",
    companyName: "companyName",
    planId: "planId",
    employeeName: "employeeNameOrSSNSearch",
    requestedFrom: "requestedDateFrom",
    requestedTo: "requestedrequestedDateTo",
    filterOut: "filterOut",
    OrderBy: "isAscendingByRequestedDate",
    from: "from",
  },
  [manageTransactionFormNames.MANAGE_LOAN]: {
    sort: "sort",
    pill: "pill",
    companyId: "companyId",
    companyName: "companyName",
    planId: "planId",
    employeeName: "employeeNameOrSSNSearch",
    requestedFrom: "requestedDateFrom",
    requestedTo: "requestedrequestedDateTo",
    filterOut: "filterOut",
    isAscending: "isAscending",

    // optionsinFilter: "optionsinFilter",
  },
};

export const MANAGE_TRANSACTION_MENU = [
  {
    id: REVIEW_SCREEN_DATA_MAPPING.APPROVAL,
    label: "Approval",
    path: MANAGE_TRANSACTION_ROUTES.APPROVAL,
    contentHeader: "Approval",
    breadCrumbs: [],
    childRoutes: [MANAGE_TRANSACTION_ROUTES.PENDINGWITHDRAWAL],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.DRAFT,
    label: "Draft",
    path: MANAGE_TRANSACTION_ROUTES.DRAFT,
    contentHeader: "Draft",
    breadCrumbs: [],
    // childRoutes: [
    //   MANAGE_TRADE_ROUTES.ADD_CUSTODIAN,
    //   MANAGE_TRADE_ROUTES.CUSTODIAN_DETAIL,
    // ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.HISTORY,
    label: "History",
    path: MANAGE_TRANSACTION_ROUTES.HISTORY,
    contentHeader: "Transaction History",
    breadCrumbs: [],
    childRoutes: [MANAGE_TRANSACTION_ROUTES.HISTORY_DETAILS],
    // childRoutes: [MANAGE_TRANSACTION_ROUTES.PENDINGWITHDRAWAL],
  },
];

export const ALL_MANAGE_TRANSACTION_ROUTES = [
  ...MANAGE_TRANSACTION_MENU,
  // {
  //   id: REVIEW_SCREEN_DATA_MAPPING.APPROVAL,
  //   contentHeader: "Approval",
  //   path: MANAGE_TRANSACTION_ROUTES.APPROVAL,
  //   breadCrumbs: [
  //     {
  //       label: "Approval",
  //       link: MANAGE_TRANSACTION_ROUTES.APPROVAL,
  //     },
  //   ],
  // },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.APPROVAL,
    contentHeader: "Approval",
    path: MANAGE_TRANSACTION_ROUTES.PENDINGWITHDRAWAL,
    breadCrumbs: [
      {
        label: "Withdrawal Approval",
        link: MANAGE_TRANSACTION_ROUTES.PENDINGWITHDRAWAL,
      },
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.APPROVAL,
    contentHeader: "Approval",
    path: MANAGE_TRANSACTION_ROUTES.PENDINGLOAN,
    breadCrumbs: [
      {
        label: "Loan Approval",
        link: MANAGE_TRANSACTION_ROUTES.PENDINGLOAN,
      },
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.APPROVAL,
    contentHeader: "Approval",
    path: MANAGE_TRANSACTION_ROUTES.PENDINGLOAN,
    breadCrumbs: [
      {
        label: "Loan Approval",
        link: MANAGE_TRANSACTION_ROUTES.PENDINGLOAN,
      },
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.HISTORY,
    path: MANAGE_TRANSACTION_ROUTES.HISTORY,
    contentHeader: "Transaction History",
    breadCrumbs: [],
    childRoutes: [MANAGE_TRANSACTION_ROUTES.HISTORY_DETAILS],
    // childRoutes: [MANAGE_TRANSACTION_ROUTES.PENDINGWITHDRAWAL],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.HISTORY,
    contentHeader: "Transaction History Details",
    path: MANAGE_TRANSACTION_ROUTES.ROLLOVER_HISTORY_DETAILS,
    breadCrumbs: [
      {
        label: "Transaction History Details",
        link: MANAGE_TRANSACTION_ROUTES.ROLLOVER_HISTORY_DETAILS,
      },
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.HISTORY,
    contentHeader: "Transaction History Details",
    path: MANAGE_TRANSACTION_ROUTES.DISTRIBUTION_HISTORY_DETAILS,
    breadCrumbs: [
      {
        label: "Transaction History Details",
        link: MANAGE_TRANSACTION_ROUTES.DISTRIBUTION_HISTORY_DETAILS,
      },
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.HISTORY,
    contentHeader: "Transaction History Details",
    path: MANAGE_TRANSACTION_ROUTES.LOAN_HISTORY_DETAILS,
    breadCrumbs: [
      {
        label: "Transaction History Details",
        link: MANAGE_TRANSACTION_ROUTES.LOAN_HISTORY_DETAILS,
      },
    ],
  },
  {
    id: REVIEW_SCREEN_DATA_MAPPING.HISTORY,
    contentHeader: "Transaction History Details",
    path: MANAGE_TRANSACTION_ROUTES.TRANSFER_HISTORY_DETAILS,
    breadCrumbs: [
      {
        label: "Transaction History Details",
        link: MANAGE_TRANSACTION_ROUTES.TRANSFER_HISTORY_DETAILS,
      },
    ],
  },
  // {
  //   id: REVIEW_SCREEN_DATA_MAPPING.DRAFT,
  //   contentHeader: "Draft",
  //   path: MANAGE_TRANSACTION_ROUTES.DRAFT,
  //   breadCrumbs: [
  //     {
  //       label: "Draft",
  //       link: MANAGE_TRANSACTION_ROUTES.DRAFT,
  //     },
  //   ],
  // },
];

export const RECORDS_TO_FETCH = 20;
